import { Card } from "../../components";

export default function LeaveApprovalPage() {
  return (
    // <div className={"section"}>
    //   <div className={"section-body"}>
        <Card >
          children over here !!!
        </Card>
    //   </div>
    // </div>
  );
}
